import { Box } from '@hover/blueprint';
import React, { useRef } from 'react';

import { DesignMenu } from 'src/modules/designStudio/components/DesignMenu';
import type { UILayerProps } from 'src/modules/designStudio/components/DesignStudio/UILayer/types';
import { UIKind } from 'src/modules/designStudio/components/DesignStudio/UILayer/types';
import { NavBar } from 'src/modules/designStudio/components/NavBar';
import {
  InteractiveRenderingToolbar,
  Toolbar,
} from 'src/modules/designStudio/components/Toolbar';
import { Mode, UILayerProvider } from 'src/modules/designStudio/providers';
import { useMode } from 'src/shared/hooks';
import { useMountToast } from 'src/shared/providers/Toaster';

interface LandscapeUIProps extends UILayerProps {
  closeMenu: () => void;
}

const LandscapeUI = ({
  setMenu,
  menu,
  shouldDisplayToolbar,
  viewer,
  jobId,
  isOnline,
  requestingOrgName,
  closeMenu,
}: LandscapeUIProps) => {
  const toolbarRef = useRef(null);

  useMountToast('landscape-container');
  const mode = useMode();
  const isInteractiveRendering = mode === Mode.INTERACTIVE_RENDERING;

  return (
    <UILayerProvider kind={UIKind.LANDSCAPE}>
      {shouldDisplayToolbar && (
        <Box id="landscape-container">
          <NavBar isOnline={isOnline} menu={menu} setMenu={setMenu} />
          <Box flexDirection="column">
            <DesignMenu
              closeMenu={closeMenu}
              jobId={jobId}
              menu={menu}
              requestingOrgName={requestingOrgName}
              toolbarRef={toolbarRef}
              viewer={viewer}
            />
            {isInteractiveRendering ? (
              <InteractiveRenderingToolbar
                menu={menu}
                ref={toolbarRef}
                setMenu={setMenu}
              />
            ) : (
              <Toolbar menu={menu} ref={toolbarRef} setMenu={setMenu} />
            )}
          </Box>
        </Box>
      )}
    </UILayerProvider>
  );
};

export { LandscapeUI };
